import React from "react";
import { Box, Grid, Typography, Paper, Stack } from "@mui/material";
import { feedback } from "../../constants";

const InstallCard = ({ title, name, content, img }) => (
  <Paper
    elevation={6}
    sx={{
      borderRadius: 3,
      p: 3,
      maxWidth: 340,
      bgcolor: "rgba(15,23,42,0.85)",
      border: "1px solid rgba(148,163,184,0.25)",
    }}
  >
    <Stack spacing={2}>
      <Box component="img" src={img} alt={title} sx={{ width: "100%", borderRadius: 2 }} />
      <Typography variant="h6" sx={{ color: "#fff", fontWeight: 600 }}>
        {name}
      </Typography>
      <Typography variant="body2" sx={{ color: "rgba(226,232,240,0.8)" }}>
        {content}
      </Typography>
    </Stack>
  </Paper>
);

const InstallationOverview = () => {
  return (
    <Box component="section" id="install" sx={{ py: 10, position: "relative" }}>
      <Box
        className="blue__gradient"
        sx={{
          position: "absolute",
          right: "-40%",
          width: "65%",
          height: "65%",
          top: "20%",
          zIndex: 0,
        }}
      />

      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 8, position: "relative", zIndex: 1 }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: "#fff",
            fontFamily: "Poppins, sans-serif",
          }}
        >
          Fuel Pro Installation
        </Typography>

        <Typography
          variant="body1"
          sx={{
            maxWidth: 450,
            color: "rgba(226,232,240,0.8)",
          }}
        >
          Each install includes our custom hardware, on-site setup, and provisioning
          of the cloud-connected software needed to bring your ATG online.
        </Typography>
      </Stack>

      <Grid 
        container 
        spacing={4} 
        justifyContent="start"
        sx={{ position: "relative", zIndex: 1 }}
      >
        {feedback.map((f) => (
          <Grid item xs={12} sm={6} md={4} key={f.id}>
            <InstallCard {...f} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default InstallationOverview;
